(() => {
  if (window.Shopify?.designMode || window.__stTractorBeamEngagementV2) return;

  const HERO = document.querySelector('.st-fp-hero[data-page-version]');
  const VERSION = HERO?.dataset.pageVersion;
  if (!['st_first_purchase_tb_v2', 'st_first_purchase_tb_v3'].includes(VERSION)) return;
  window.__stTractorBeamEngagementV2 = true;
  const EVENT = 'st_lp:engagement';
  const ROCKET_HANDLE = 'rocket-flower-enzyme-fermented-colombia';
  const ROCKET_DESTINATION = '/collections/coffees/products/' + ROCKET_HANDLE;
  const seen = new Set();
  const timers = new Map();
  let observer;

  function analyticsAllowed() {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    } catch (_) {
      return false;
    }
  }

  function publish(action, extra = {}) {
    if (!analyticsAllowed()) return false;
    const properties = { action, page_version: VERSION, ...extra };
    let published = false;
    if (typeof window.Shopify?.analytics?.publish === 'function') {
      window.Shopify.analytics.publish(EVENT, properties);
      published = true;
    }
    if (window.STStorefrontAnalytics?.capture(action, properties)) published = true;
    return published;
  }

  function visibleHalf(element) {
    if (document.visibilityState !== 'visible') return false;
    const rect = element.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;
    const visibleWidth = Math.max(0, Math.min(rect.right, innerWidth) - Math.max(rect.left, 0));
    const visibleHeight = Math.max(0, Math.min(rect.bottom, innerHeight) - Math.max(rect.top, 0));
    return (visibleWidth * visibleHeight) / (rect.width * rect.height) >= 0.5;
  }

  const targets = [
    ['st_lp_hero_view', '.st-fp-hero h1'],
    ['st_lp_buy_view', '[id$="__featured_product_jFYrH9"] button.add-to-cart-btn'],
    ['st_lp_coffee_view', '[id$="__rich_text_qQ3atB"] h2'],
    ['st_lp_roaster_view', '[id$="__rich_text_7jwTJ7"] h2'],
    ['st_lp_companion_view', '.st-fp-companion-grid'],
    ['st_lp_subscription_view', '[id$="__rich_text_mthQDx"] h2'],
    ['st_lp_faq_view', '[id$="__faq_URTJWq"] h2']
  ];

  function clearTimers() {
    for (const timer of timers.values()) clearTimeout(timer);
    timers.clear();
  }

  function stopObserver() {
    observer?.disconnect();
    observer = undefined;
    clearTimers();
  }

  function startObserver() {
    if (observer || !analyticsAllowed() || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        const action = entry.target.dataset.stEngagementAction;
        if (!action || seen.has(action)) continue;
        if (entry.intersectionRatio < 0.5 || document.visibilityState !== 'visible') {
          clearTimeout(timers.get(action));
          timers.delete(action);
          continue;
        }
        if (timers.has(action)) continue;
        timers.set(action, setTimeout(() => {
          timers.delete(action);
          if (!analyticsAllowed() || !visibleHalf(entry.target) || seen.has(action)) return;
          const extra = action === 'st_lp_rocket_view'
            ? { product_handle: ROCKET_HANDLE, destination: ROCKET_DESTINATION } : {};
          if (publish(action, extra)) {
            seen.add(action);
            observer?.unobserve(entry.target);
          }
        }, 1000));
      }
    }, { threshold: [0, 0.5, 1] });
    for (const [action, selector] of targets) {
      const element = document.querySelector(selector);
      if (!element || seen.has(action)) continue;
      element.dataset.stEngagementAction = action;
      observer.observe(element);
    }
  }

  function reconcilePrivacy() {
    if (analyticsAllowed()) {
      startObserver();
    } else {
      stopObserver();
    }
  }

  function onClick(event) {
    if (!analyticsAllowed() || !(event.target instanceof Element)) return;
    const companionSummary = event.target.closest('.st-fp-companions summary');
    if (companionSummary && !companionSummary.parentElement.open) {
      publish('st_lp_companion_open');
      return;
    }
    const faq = event.target.closest('[id$="__faq_URTJWq"] button[aria-expanded]');
    if (faq && faq.getAttribute('aria-expanded') === 'false') {
      publish('st_lp_faq_open', { faq_question: faq.textContent.trim().replace(/\s+/g, ' ').slice(0, 80) });
      return;
    }
    const companion = event.target.closest('[data-st-companion]');
    if (companion && event.target.closest('button[type="submit"]')) {
      publish('st_lp_cart_click', { product_handle: companion.dataset.stCompanion, placement: 'companion' });
      return;
    }
    const cartButton = event.target.closest('[id$="__featured_product_jFYrH9"] button.add-to-cart-btn');
    if (cartButton) {
      publish('st_lp_cart_click', { product_handle: 'tractor-beam-blend', placement: 'featured' });
      return;
    }
    const link = event.target.closest('a[href]');
    if (!link) return;
    if (link.matches('.st-fp-all-coffees')) publish('st_lp_coffee_click', { destination: '/collections/coffees', placement: 'companion' });
    else if (link.matches('.st-fp-cta')) publish('st_lp_primary_click');
    else if (link.closest('[id$="__rich_text_qQ3atB"]')) publish('st_lp_coffee_click');
    else if (link.closest('[id$="__rich_text_7jwTJ7"]')) publish('st_lp_roaster_click');
    else if (link.closest('[id$="__image_with_text_qWECPh"]') &&
             new URL(link.href, location.href).pathname === ROCKET_DESTINATION) {
      publish('st_lp_rocket_click', { product_handle: ROCKET_HANDLE, destination: ROCKET_DESTINATION });
    }
    else if (link.closest('[id$="__rich_text_mthQDx"]')) publish('st_lp_subscription_click');
    else if (link.closest('[id$="__rich_text_rhWanG"]') && link.getAttribute('href') === '#buy') {
      publish('st_lp_return_click');
    }
  }

  function onKlaviyoForm(event) {
    const type = event.detail?.type;
    const action = {
      open: 'st_lp_popup_open',
      close: 'st_lp_popup_close',
      submit: 'st_lp_popup_submit'
    }[type];
    if (!action) return;
    const id = String(event.detail?.formId || '');
    publish(action, /^[A-Za-z0-9_-]{1,20}$/.test(id) ? { form_id: id } : {});
  }

  function init() {
    document.addEventListener('click', onClick, true);
    window.addEventListener('klaviyoForms', onKlaviyoForm);
    document.addEventListener('visitorConsentCollected', reconcilePrivacy);
    document.addEventListener('shopifyCustomerPrivacyApiLoaded', reconcilePrivacy);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') clearTimers();
      else reconcilePrivacy();
    });
    reconcilePrivacy();
    window.Shopify?.loadFeatures?.(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => { if (!error) reconcilePrivacy(); }
    );
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
